import { render, staticRenderFns } from "./NbaBlog.vue?vue&type=template&id=6a2736b5&scoped=true"
import script from "./NbaBlog.vue?vue&type=script&lang=js"
export * from "./NbaBlog.vue?vue&type=script&lang=js"
import style0 from "./NbaBlog.vue?vue&type=style&index=0&id=6a2736b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2736b5",
  null
  
)

export default component.exports